import React from "react";
import { useTranslation } from 'react-i18next';
import "../styles/RentTutorialStriemoKey.css";


const ReturnTutorialStriemoKey = () => {
    const { t } = useTranslation();
    return (
        <main>
          <section className="app__return-ja" id="appreturn-jp">
            <div className="inner-app">
              <h2 className="section-ttl">
                {t('Thank you for using our service')}
              </h2>

              <ul className="rental-warapper">
                {/* 1 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/parking.png" alt="パーキングレバー" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">
                      1.Striemoのパーキングブレーキをかけてください。
                    </h3>
                  </div>
                  <p className="rental-discription">
                    左のブレーキレバーを強く握り、ロックレバーを人差し指で引き、固定してください。
                  </p>
                </li>

                {/* 2 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/btn.png" alt="電源ボタン" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">2.Striemoの電源を切ってください。</h3>
                  </div>
                </li>

                {/* 3 */}
                <li className="rental-list">
                  <div className="use__img-area">
                    <figure className="use__img">
                      <img src="/images/striemo_key/striemo-key.png" alt="ダイヤルロック" />
                    </figure>
                  </div>
                  <div className="rental__ttl-area">
                    <h3 className="rental__ttl">
                      3.Striemoの後輪に赤いダイヤルロックを取り付けてください。
                    </h3>
                  </div>
                  <p className="rental-discription">
                    ※解除時の番号以外の数字に設定し、ロックをかけてください。
                  </p>
                </li>
              </ul>

              <div className="cp_arrows">
                <div className="cp_arrow"></div>
                <div className="cp_arrow"></div>
              </div>

              <div className="return-warraper">
                <h3 className="rental__ttl">
                  ご自身の端末で、予約サイトから「選択したモビリティを返却する」ボタンを押して、返却手続きを完了させてください。
                </h3>
              </div>
            </div>
          </section>
        </main>
    );
};

export default ReturnTutorialStriemoKey;
